import { Dialog as MUIDialog, DialogProps } from '@mui/material';
import React from 'react';

export const Dialog = (props: DialogProps) => <MUIDialog {...props} />;
